// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSearchNewbuildingLayoutsDesktopRequest,
  TSearchNewbuildingLayoutsDesktopModel,
  IMappers,
  TSearchNewbuildingLayoutsDesktopResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISearchNewbuildingLayoutsForDesktopResponseSchema } from '../../entities/entities/SearchNewbuildingLayoutsForDesktopResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSearchNewbuildingLayoutsDesktopModel(
  parameters: TSearchNewbuildingLayoutsDesktopRequest,
): TSearchNewbuildingLayoutsDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-offers',
    pathApi: '/v1/search-newbuilding-layouts-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISearchNewbuildingLayoutsDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSearchNewbuildingLayoutsDesktopRequest;
}

export async function fetchSearchNewbuildingLayoutsDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISearchNewbuildingLayoutsDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSearchNewbuildingLayoutsDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSearchNewbuildingLayoutsDesktopModel(parameters),
    config,
  )) as FetchResponse<TSearchNewbuildingLayoutsDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISearchNewbuildingLayoutsForDesktopResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSearchNewbuildingLayoutsDesktopResponse>;
}
